import React from "react";

import { images } from '../../../../../config';
import {FreeSelectionFloatingPinContainer} from "./FreeSelectionFloatingPinStyle";


const FreeSelectionFloatingPin = props => {
    if (!props.isDest && !props.isOrigin) {
        return null;
    }
    let pinToRender;
    if (!props.inZone) {
        pinToRender = images.ooz_marker_icon;
    } else if (props.isDest) {
        pinToRender = images.dest_marker_icon;
    } else {
        pinToRender = images.origin_marker_icon;
    }

    return (
        <FreeSelectionFloatingPinContainer>
            <img src={pinToRender} alt="pin"/>
        </FreeSelectionFloatingPinContainer>
    );
};

export default FreeSelectionFloatingPin;



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelectionFloatingPin/FreeSelectionFloatingPin.js